var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my_pag" },
    [
      _c("el-pagination", {
        attrs: {
          background: "",
          layout: _vm.optionsCom.layout,
          total: _vm.optionsCom.total,
          "page-sizes": _vm.optionsCom.pageSizes,
          "page-size": _vm.optionsCom.pageSize,
          "current-page": _vm.optionsCom.pageIndex,
        },
        on: {
          "size-change": _vm.sizeChangeHandle,
          "current-change": _vm.currentChangeHandle,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }